import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Store} from '@ngrx/store';
import {InitialLoaderHelper} from '@shared/helpers/initial-loader.helper';
import {AppState} from '@store';
import {LeftPanelActions} from '@store/left-panel/actions';
import {leftPanelSelector} from '@store/left-panel/selectors';
import {Observable} from 'rxjs';

/**
 * 'AppContainer' class definition.
 */
@UntilDestroy()
@Component({
	selector: 'app-root',
	template: `
		<app-root-component
			*ngIf="hideLoader"
			[hideLeftPanel]="hideLeftPanel$ | async"
			(toggleLeftPanel)="onToggleLeftPanel()"
		></app-root-component>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppContainer implements OnInit {
	/**
	 * Auxiliary variable for accessing to Observable of hide left panel.
	 */
	public readonly hideLeftPanel$: Observable<boolean>;

	/** Auxiliary 'hideLoader' variable. */
	public hideLoader = false;

	/**
	 * Constructor for AppContainer.
	 */
	constructor(private store: Store<AppState>) {
		this.hideLeftPanel$ = this.store.select(leftPanelSelector.hideLeftPanel);
	}

	/**
	 * Default Angular framework 'ngOnInit' Lifecycle hook.
	 * @returns {void}
	 */
	public ngOnInit(): void {
		this.showAppLoader();
	}

	/**
	 * On toggle left panel.
	 * @returns {void}
	 */
	public onToggleLeftPanel(): void {
		this.store.dispatch(LeftPanelActions.toggle());
	}

	/**
	 * Show app loader.
	 * @returns {void}
	 */
	public showAppLoader(): void {
		InitialLoaderHelper.remove();
		this.hideLoader = true;
	}
}
